import {URLBILLETERA} from "../../Constantes";
import {reducirHash} from "./reducirHash";

export const obtenerLinkReferido = ({codigo}) => {

    let url = URLBILLETERA + '?id=' + reducirHash({hash: codigo, largo: 7});

    return url

}